





























import Vue from "vue";
import { AssessmentListingHeaderOptions } from "@/interfaces/responses/assessments/assessments";
import { mapGetters } from "vuex";
import { SITE_DIRECTION } from "@/store/modules/common/constants";
import { ASSESSMENT_LISTING } from "@/store/modules/recruiter/constants";

export default Vue.extend({
  name: "AssessmentsListingHead",
  data() {
    return {
      table_headers: [] as AssessmentListingHeaderOptions[]
    };
  },
  watch: {
    get_site_direction() {
      this.set_header();
    }
  },
  computed: {
    ...mapGetters("common", {
      get_site_direction: SITE_DIRECTION
    }),
    ...mapGetters("recruiter", {
      get_assessment_listing: ASSESSMENT_LISTING
    })
  },
  mounted() {
    this.set_header();
    this.sort_assessment;
  },
  methods: {
    set_header() {
      this.table_headers = [
        {
          title: this.$t("assessments.listing.col-1"),
          cols: 1
        },
        {
          title: this.$t("assessments.listing.col-3"),
          cols: 2
        },
        {
          title: this.$t("assessments.listing.col-2"),
          cols: 4
        },
        {
          title: this.$t("Score"),
          cols: 1,
          sortable: true,
          direction: "desc"
        },
        {
          title: this.$t("assessments.listing.col-4"),
          cols: 3
        }
      ];
    },
    sort_assessment(ind: number) {
      this.table_headers[ind].direction =
        this.table_headers[ind].direction === "asc" ? "desc" : "asc";

      if (this.table_headers[ind].direction === "asc") {
        this.get_assessment_listing?.data?.assessments.sort(
          (a: any, b: any) => {
            return a.score - b.score;
          }
        );
      } else {
        this.get_assessment_listing?.data?.assessments.sort(
          (a: any, b: any) => {
            return b.score - a.score;
          }
        );
      }
    }
  }
});
